export const TO_DO = 'TO_DO';
export const IN_PROGRESS = 'IN_PROGRESS';
export const DONE = 'DONE';
